module.exports = __webpack_public_path__ + "static/media/time-over.d9433f7b.mp3";